
import { Vue, Component, Prop } from "vue-property-decorator";
import { CustomHelper } from "@newview/tools";
declare var $: any;
@Component({
  name: "dateAreaSel"
})
export default class dateAreaSel extends Vue {
  dateshow=0;
  optionsDate={
      disabledDate (date) {
          return date && date.valueOf() > Date.now();
      }
  };
  datepickerVal = [
    CustomHelper.ForMatDate(new Date(), "yyyy-MM-dd"),
    CustomHelper.ForMatDate(new Date(), "yyyy-MM-dd")
  ];
  startTime=CustomHelper.ForMatDate(new Date(), "yyyy-MM-dd 00:00:00")
  @Prop({ default: {} }) changeDateArea!: Function; //是否显示搜索按钮
  changeSelDate(index){
      this.dateshow=index;
      var nowdate:any = new Date();
      switch (index) {
        case 0:
          this.startTime=CustomHelper.ForMatDate(new Date(), "yyyy-MM-dd 00:00:00")
          break;
        case 1:
          this.startTime=CustomHelper.ForMatDate(new Date(nowdate-7*24*3600*1000), "yyyy-MM-dd hh:mm:ss")
          break;
        case 2:
          this.startTime=CustomHelper.ForMatDate(new Date(nowdate-14*24*3600*1000), "yyyy-MM-dd hh:mm:ss")
          break;
        case 3:
          this.startTime=CustomHelper.ForMatDate(new Date(nowdate-30*24*3600*1000), "yyyy-MM-dd hh:mm:ss")
          break;
        case 3:
          this.startTime=CustomHelper.ForMatDate(new Date(nowdate-30*24*3600*1000), "yyyy-MM-dd hh:mm:ss")
          break;
        default:
          break;
      }
      this.datepickerVal = [
        this.startTime,
        CustomHelper.ForMatDate(new Date(), "yyyy-MM-dd")
      ];
      this.changeDateArea(this.startTime);

  }
  DatePickerSel(aa){
    console.log(aa)
    this.changeDateArea(aa[0]+" 00:00:00",aa[1]+" 23:59:59");
  }
}
